/**
 * BMI calculation utilities
 * All calculations work with metric values (cm, kg) internally
 */

/**
 * Calculate BMI from height (cm) and weight (kg)
 */
export const calculateBMI = (heightCm: number, weightKg: number): number => {
  if (heightCm <= 0 || weightKg <= 0) return 0;
  
  const heightM = heightCm / 100;
  return weightKg / (heightM * heightM);
};

/**
 * Get BMI category based on BMI value
 */
export const getBMICategory = (bmi: number): string => {
  if (bmi < 18.5) return 'Underweight';
  if (bmi < 25) return 'Normal weight';
  if (bmi < 30) return 'Overweight';
  return 'Obese';
};

/**
 * Get BMI category color for display
 */
export const getBMICategoryColor = (bmi: number): string => {
  if (bmi < 18.5) return 'text-primary';
  if (bmi < 25) return 'text-green-600';
  if (bmi < 30) return 'text-yellow-600';
  return 'text-red-600';
};

/**
 * Format BMI value for display
 */
export const formatBMI = (bmi: number): string => {
  return bmi.toFixed(1);
};
